/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

export class ApiSortModel {
  field: string;
  direction: string;
}
